import styled from "styled-components";
import { responsiveMap } from "../../../Grid/_utils/responsiveObserve";

export const _MargauxMotinVideoRoot = styled.div`
  width: 100%;
  height: 100%;
  position: relative;
  overflow: visible;
  max-width: 1118px;
  margin: 16px auto 64px;

  @media ${responsiveMap.mobile} {
    margin: 65px auto 94px;
  }

  .margaux-motin-video {
    .landing-video-yt {
      z-index: 1;
    }
  }

  .landing-video-container {
    @media ${responsiveMap.mobile} {
      aspect-ratio: 327/225;
    }
  }

  .margaux-motin-video-decorations {
    position: absolute;
    top: 0;
    right: 0;
    transform: translateY(100%) translateX(50%);
    transition: transform 1s cubic-bezier(0.97, 0.15, 0.68, 0.64),
      opacity 1s cubic-bezier(0.97, 0.15, 0.68, 0.64) 0.3s;
    opacity: 1;

    @media ${responsiveMap.mobile} {
      transform: translateY(-120%) translateX(-100%);
    }

    & img {
      width: 100%;
      max-width: 109px;
      height: auto;
      flex-shrink: 0;
      aspect-ratio: 1/1;
      object-fit: cover;
      @media ${responsiveMap.mobile} {
        max-width: 62px;
      }
    }

    &.playerShown {
      transform: translateY(100%) translateX(110%);
      opacity: 0;
      transition: transform 1s cubic-bezier(0.97, 0.15, 0.68, 0.64),
        opacity 1s cubic-bezier(0.97, 0.15, 0.68, 0.64) 0.3s;
      @media ${responsiveMap.mobile} {
        opacity: 1;
        transform: translateY(-120%) translateX(-100%);
      }
    }
  }
  .margaux-motin-video-decorations-2 {
    position: absolute;
    bottom: 0;
    right: 25%;
    transform: translateY(50%);
    transition: transform 1s cubic-bezier(0.97, 0.15, 0.68, 0.64),
      opacity 1s cubic-bezier(0.97, 0.15, 0.68, 0.64) 0.3s;
    opacity: 1;

    @media ${responsiveMap.mobile} {
      right: 0;
      transform: translateY(120%);
    }

    & img {
      width: 100%;
      max-width: 107px;
      height: auto;
      flex-shrink: 0;
      aspect-ratio: 1/1;
      object-fit: cover;
      @media ${responsiveMap.mobile} {
        max-width: 64px;
      }
    }

    &.playerShown {
      transform: translateY(105%);
      opacity: 0;
      transition: transform 1s cubic-bezier(0.97, 0.15, 0.68, 0.64),
        opacity 1s cubic-bezier(0.97, 0.15, 0.68, 0.64) 0.3s;
      @media ${responsiveMap.mobile} {
        opacity: 1;
        transform: translateY(120%);
      }
    }
  }

  .margaux-motin-video-decorations-3 {
    position: absolute;
    bottom: 0;
    left: 0;
    transform: translateY(20%) translateX(-35%);
    transition: all 1s cubic-bezier(0.97, 0.15, 0.68, 0.64);

    & img {
      width: 100%;
      max-width: 224px;
      height: auto;
      flex-shrink: 0;
      aspect-ratio: 56/85;
      object-fit: cover;
    }

    &.playerShown {
      transform: translateY(20%) translateX(-105%);
    }

    @media ${responsiveMap.mobile} {
      display: none;
    }
  }
`;
